export interface AiSourceEntry {
  type?: string;
  refId?: string;
  title?: string;
  url?: string;
  via?: string;
}

/**
 * The sources whose information appears in an AI reply or draft.
 *
 * Legacy source metadata meant "retrieved," not "used in this reply."
 * "record-source-use:*" = the model recorded the source as used;
 * "answer-match:*" = the service verified the source's answer text
 * appears in the reply. Both mean "used," so both render.
 */
export function usedAiSources(aiMeta?: { sources?: unknown } | null): AiSourceEntry[] {
  if (!Array.isArray(aiMeta?.sources)) return [];
  return (aiMeta.sources as AiSourceEntry[]).filter(
    (source) =>
      source?.via?.startsWith('record-source-use:') || source?.via?.startsWith('answer-match:'),
  );
}
